module.exports = {
          srcSet: __webpack_public_path__ + "433a2b53.jpg"+" 700w"+","+__webpack_public_path__ + "f9361bc9.jpg"+" 1400w"+","+__webpack_public_path__ + "71c12d28.jpg"+" 1600w",
          images:[ {path: __webpack_public_path__ + "433a2b53.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "f9361bc9.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "71c12d28.jpg",width: 1600,height: 1200}],
          src: __webpack_public_path__ + "433a2b53.jpg",
          toString:function(){return __webpack_public_path__ + "433a2b53.jpg"},
          
          width: 700,
          height: 525
        }